import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  Link,
} from "@mui/material";
import { CheckCircle, Update, Block, Error } from "@mui/icons-material";
import { CsvImportResultRow } from "../model";

export interface ImportResultsTableProps {
  results: CsvImportResultRow[];
}

// Helper to get name from either string or object with name property
const getActionName = (action: any): string => {
  if (!action) return "UNKNOWN";
  if (typeof action === "string") return action;
  if (typeof action === "object" && action.name) return action.name;
  return String(action);
};

const getActionChip = (action: any) => {
  const actionName = getActionName(action);
  if (actionName === "CREATED") {
    return <Chip icon={<CheckCircle />} label="Créé" size="small" color="success" />;
  }
  if (actionName === "UPDATED") {
    return <Chip icon={<Update />} label="Mis à jour" size="small" color="info" />;
  }
  if (actionName === "SKIPPED") {
    return <Chip icon={<Block />} label="Ignoré" size="small" color="default" />;
  }
  if (actionName === "FAILED") {
    return <Chip icon={<Error />} label="Échec" size="small" color="error" />;
  }
  return <Chip label={actionName} size="small" />;
};

export const ImportResultsTable = ({ results }: ImportResultsTableProps) => {
  if (!results || results.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 4 }}>
        Aucun résultat à afficher
      </Typography>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600 }}>Ligne</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Réalisation</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Erreur</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {results.map((result) => (
            <TableRow
              key={result.rowNumber}
              sx={{
                backgroundColor:
                  getActionName(result.action) === "FAILED" ? "error.lighter" : undefined,
              }}
            >
              <TableCell>{result.rowNumber}</TableCell>
              <TableCell>{getActionChip(result.action)}</TableCell>
              <TableCell>
                {result.realizationId ? (
                  <Link
                    href={`/realizations/${result.realizationId}/view`}
                    target="_blank"
                    rel="noopener"
                  >
                    {result.realizationName || result.realizationId.slice(0, 8) + "..."}
                  </Link>
                ) : (
                  "-"
                )}
              </TableCell>
              <TableCell>
                {result.error ? (
                  <Typography variant="caption" color="error">
                    {result.error}
                  </Typography>
                ) : (
                  "-"
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
